export default {
  // CustomComponents
  //search: () => import('../components/search/search.vue'),

  // Pages
  vacanciesDetail: () => import('./pages/vacancies/vacancies-detail'),
  vacanciesList: () => import('./pages/vacancies/vacancies-list'),
  vacanciesEdit: () => import('./pages/vacancies/vacancies-edit'),
  vacanciesCreate: () => import('./pages/vacancies/vacancies-create'),
  vacanciesMyList: () => import('./pages/vacancies/vacancies-my-list'),
  vacanciesListAdmin: () => import('./pages/vacancies/vacancies-list-admin'),

  // Pages uikit2022
  uiKit: () => import('./pages/ui-kit/ui-kit')
}
